import React, { useEffect, useState } from 'react';
import { Space, Table, Tag, Button, Image, Input, Flex, Card } from 'antd';
import { useSearchParams } from "react-router";
import { EditOutlined, EyeOutlined, PlusCircleOutlined } from '@ant-design/icons';
import ProductCollectionService from 'services/product_collection';
import StoreSettingService from 'services/store_setting';
import ProductCollectionModal from 'components/product_collection';
const { Search } = Input;
const service = new ProductCollectionService();
const storeSettingService = new StoreSettingService();


const ProductCollection = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [searchParams] = useSearchParams();

  const loadData = async () => {
    setLoading(true);
    try {
      const params = { ...filters, ...Object.fromEntries(searchParams) };
      const result = await service.list(params);
      setData(result || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [filters, searchParams]);

  useEffect(() => {
    loadWebsiteUrl();
  }, []);

  const loadWebsiteUrl = async () => {
    try {
      const web = await storeSettingService.getWebsiteSetting();
      if (web?.url) {
        setWebsiteUrl(`https://${web.url}.sipro.store`);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getViewLink = (record) => {
    const path = record?.url_handle ? `/collection/${record.url_handle}` : `/product-collection/${record.id}`;
    if (websiteUrl) {
      return `${websiteUrl}${path}`;
    }
    return path;
  };

  const renderCollectionType = (condition = {}) => {
    const type = condition.type || 'manual';
    const labelByType = {
      manual: 'Theo sản phẩm',
      tag: 'Theo tag',
      category: 'Theo danh mục',
    };
    const colorByType = {
      manual: 'blue',
      tag: 'green',
      category: 'purple',
    };

    return <Tag color={colorByType[type] || 'default'}>{labelByType[type] || type}</Tag>;
  };

  const columns = [
    {
      title: 'Hình ảnh',
      render: (_, record) => {
        const image = record.avatar || record.image;
        return image ? <Image src={image.url} width={50} /> : null;
      },
    },
    {
      title: 'Tên',
      dataIndex: 'title',
    },
    {
      title: 'Mô tả',
      dataIndex: 'description',
    },
    {
      title: 'Cách chọn sản phẩm',
      render: (_, record) => renderCollectionType(record.collection_condition),
    },
    {
      title: 'Hành động',
      render: (_, record) => (
        <Space>
          <Button icon={<EyeOutlined />} onClick={() => window.open(getViewLink(record), '_blank')} />
          <Button
            icon={<EditOutlined />}
            onClick={() => {
              setSelectedId(record.id);
              setOpenModal(true);
            }}
          />
        </Space>
      ),
    },
  ];

  return (
    <Space direction="vertical" style={{ width: '100%' }}>

      <Card>
        <Flex style={{ marginBottom: 16, gap: 16 }}>
          <Search placeholder="Tìm kiếm" onSearch={(value) => setFilters({ ...filters, info: value })} />

        </Flex>
        <Flex justify="end">
          <Button
            type="primary"
            onClick={() => {
              setSelectedId(null);
              setOpenModal(true);
            }}
          >
            <PlusCircleOutlined /> Tạo mới
          </Button>
        </Flex>
      </Card >



      <Card>
        <Table columns={columns} dataSource={data} loading={loading} rowKey="id" />
      </Card>



      <ProductCollectionModal
        open={openModal}
        id={selectedId}
        onClose={() => {
          setOpenModal(false);
          setSelectedId(null);
        }}
        onChange={loadData}
      />
    </Space>
  )

}
export default ProductCollection;